export default "__VITE_ASSET__uoPaNJYZ__"